import { DropdownItem, MobileMenuSectionProps } from '@/types';
import { Link } from 'react-router-dom';

const MobileMenuSection = ({ title, items, closeMenu }: MobileMenuSectionProps) => {

  const handleItemClick = (item: DropdownItem): void => {
    item.onClick?.();
    closeMenu?.();
  };

  return (<div>
    <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3">
      {title}
    </h3>
    <div className="space-y-1">
      {items.map((item, index) => (
        <Link to={item.route || '#'}>
          <button
            key={index}
            onClick={() => handleItemClick(item)}
            className="flex items-center w-full px-3 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-lg transition-colors duration-150"
          >
            {item.icon && <item.icon size={16} className="mr-3 text-gray-500 dark:text-gray-400"/>}
            <span>{item.label}</span>
          </button>
        </Link>
      ))}
    </div>
  </div>)
};

export default MobileMenuSection;
